//core
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from '../../../../store/';

//Main list
const listDataSelector = (state: RootState) => state.admin.details_finance_report.list.data;
export const selectListData = createSelector(listDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'affiliateId') {
        return { ...item, type: 'finAffId', selectAll: true };
      }
      if (item.name === 'status') {
        return { ...item, type: 'detailsFinReportStatus'};
      }
      if (item.name === 'comment') {
        return { ...item, type: 'detailFinReportComment'};
      }

      return item;
    });

    return { ...data, columns: columns };
  } else {
    return data
  }

  return data;
});

const listIsFetchingSelector = (state: RootState) => state.admin.details_finance_report.list.isFetching;
export const selectIsFetchingList = createSelector(listIsFetchingSelector, (isFetching) => isFetching);

const listErrorSelector = (state: RootState) => state.admin.details_finance_report.list.error;
export const selectErrorList = createSelector(listErrorSelector, (error) => error);

export const selectListDataColumnsSort = createSelector(listDataSelector, (data) => data?.columns.filter((el: any) => el.sort === true));


//Filters
const filtersDataSelector = (state: RootState) => state.admin.details_finance_report.filters.data;
export const selectFiltersData = createSelector(filtersDataSelector, (data) => data);

const filtersIsFetchingSelector = (state: RootState) => state.admin.details_finance_report.filters.isFetching;
export const selectIsFetchingFilters = createSelector(filtersIsFetchingSelector, (isFetching) => isFetching);

const filtersErrorSelector = (state: RootState) => state.admin.details_finance_report.filters.error;
export const selectErrorFilters = createSelector(filtersErrorSelector, (error) => error);


//Adjustment
const adjustmentListDataSelector = (state: RootState) => state.admin.details_finance_report.adjustmentList.data;
export const selectAdjustmentData = createSelector(adjustmentListDataSelector, (data) => data);

const adjustmentListIsFetchingSelector = (state: RootState) => state.admin.details_finance_report.adjustmentList.isFetching;
export const selectIsFetchingAdjustmentList = createSelector(adjustmentListIsFetchingSelector, (isFetching) => isFetching);

const adjustmentListErrorSelector = (state: RootState) => state.admin.details_finance_report.adjustmentList.error;
export const selectErrorAdjustmentList = createSelector(adjustmentListErrorSelector, (error) => error);


//Adjustment reasons
const adjustmentReasonsDataSelector = (state: RootState) => state.admin.details_finance_report.adjustmentReasons.data;
export const selectAdjustmentReasonsData = createSelector(adjustmentReasonsDataSelector, (data) => data);

const adjustmentReasonsIsFetchingSelector = (state: RootState) => state.admin.details_finance_report.adjustmentReasons.isFetching;
export const selectIsFetchingAdjustmentReasons = createSelector(adjustmentReasonsIsFetchingSelector, (isFetching) => isFetching);

const adjustmentReasonsErrorSelector = (state: RootState) => state.admin.details_finance_report.adjustmentReasons.error;
export const selectErrorAdjustmentReasons = createSelector(adjustmentReasonsErrorSelector, (error) => error);

//Adjustment brands
const adjustmentBrandsDataSelector = (state: RootState) => state.admin.details_finance_report.adjustmentBrands.data;
export const selectAdjustmentBrandsData = createSelector(adjustmentBrandsDataSelector, (data) => data);

const adjustmentBrandsIsFetchingSelector = (state: RootState) => state.admin.details_finance_report.adjustmentBrands.isFetching;
export const selectIsFetchingAdjustmentBrands = createSelector(adjustmentBrandsIsFetchingSelector, (isFetching) => isFetching);

const adjustmentBrandsErrorSelector = (state: RootState) => state.admin.details_finance_report.adjustmentBrands.error;
export const selectErrorAdjustmentBrands = createSelector(adjustmentBrandsErrorSelector, (error) => error);


//Adjustment add
const adjustmentAddDataSelector = (state: RootState) => state.admin.details_finance_report.adjustmentAdd.data;
export const selectAdjustmentAddData = createSelector(adjustmentAddDataSelector, (data) => data);


//Adjustment added error
const adjustmentAddErrorSelector = (state: RootState) => state.admin.details_finance_report.adjustmentAdd.error;
export const selectAdjustmentAddError = createSelector(adjustmentAddErrorSelector, (error) => error);

//Adjustment approve
const adjustmentApproveDataSelector = (state: RootState) => state.admin.details_finance_report.adjustmentApprove.data;
export const selectAdjustmentApproveData = createSelector(adjustmentApproveDataSelector, (data) => data);


//Adjustment remove
const adjustmentRemoveDataSelector = (state: RootState) => state.admin.details_finance_report.adjustmentRemove.data;
export const selectAdjustmentRemoveData = createSelector(adjustmentRemoveDataSelector, (data) => data);

//Adjustment edit
const adjustmentEditDataSelector = (state: RootState) => state.admin.details_finance_report.adjustmentEdit.data;
export const selectAdjustmentEditData = createSelector(adjustmentEditDataSelector, (data) => data);

//Adjustment edit error
const adjustmentEditErrorSelector = (state: RootState) => state.admin.details_finance_report.adjustmentEdit.error;
export const selectAdjustmentEditError = createSelector(adjustmentEditErrorSelector, (error) => error);

//Download Details Report
const downloadDetailsReportDataSelector = (state: RootState) => state.admin.details_finance_report.downloadDetailsReport.data;
export const selectDownloadDetailsReportData = createSelector(downloadDetailsReportDataSelector, (data) => data);

//Payment change
const paymentChangeDataSelector = (state: RootState) => state.admin.details_finance_report.paymentChange.data;
export const selectPaymentChangeData = createSelector(paymentChangeDataSelector, (data) => data);

const paymentChangeErrorSelector = (state: RootState) => state.admin.details_finance_report.paymentChange.error;
export const selectPaymentChangeError = createSelector(paymentChangeErrorSelector, (error) => error);

//Manager Approve
const managerApproveDataSelector = (state: RootState) => state.admin.details_finance_report.managerApprove.data;
export const selectManagerApproveData = createSelector(managerApproveDataSelector, (data) => data);

//Cancel Manager Approve
const managerCancelApproveDataSelector = (state: RootState) => state.admin.details_finance_report.cancelManagerApprove.data;
export const selectCancelManagerApproveData = createSelector(managerCancelApproveDataSelector, (data) => data);

//To Paid Approve
const toPaidApproveDataSelector = (state: RootState) => state.admin.details_finance_report.toPaidApprove.data;
export const selectToPaidApproveData = createSelector(toPaidApproveDataSelector, (data) => data);

//Carry Over Approve
const carryOverApproveDataSelector = (state: RootState) => state.admin.details_finance_report.carryOverApprove.data;
export const selectCarryOverApproveData = createSelector(carryOverApproveDataSelector, (data) => data);

//Cancel Carry Over Approve
const cancelCarryOverApproveDataSelector = (state: RootState) => state.admin.details_finance_report.cancelCarryOverApprove.data;
export const selectCancelCarryOverApproveData = createSelector(cancelCarryOverApproveDataSelector, (data) => data);

// Change Comment
const changeCommentDataSelector = (state: RootState) => state.admin.details_finance_report.changeComment.data;
export const selectChangeCommentData = createSelector(changeCommentDataSelector, (data) => data);

//report row data
const rowDataSelector = (state: RootState) => state.admin.details_finance_report.reportRowData.data;
const rowDataIsFetchingSelector = (state: RootState) => state.admin.details_finance_report.reportRowData.isFetching;
const rowDataErrorSelector = (state: RootState) => state.admin.details_finance_report.reportRowData.error;
export const selectRowData = createSelector(rowDataSelector, (data) => data);
export const selectRowDataIsFetching = createSelector(rowDataIsFetchingSelector, (isFetching) => isFetching);
export const selectRowDataError = createSelector(rowDataErrorSelector, (error) => error);

//columns
const columnsDataSelector = (state: RootState) => state.admin.details_finance_report.columns.data;
const columnsFetchingSelector = (state: RootState) => state.admin.details_finance_report.columns.isFetching;
const columnsErrorSelector = (state: RootState) => state.admin.details_finance_report.columns.error;
export const selectColumnsData = createSelector(columnsDataSelector, (data) => data);
export const selectColumnsError = createSelector(columnsErrorSelector, (error) => error);
export const selectColumnsIsFetching = createSelector(columnsFetchingSelector, (isFetching) => isFetching);


//PaymentBreakdown
const paymentBreakdownDataSelector = (state: RootState) => state.admin.details_finance_report.paymentBreakdown.data;
const paymentBreakdownFetchingSelector = (state: RootState) => state.admin.details_finance_report.paymentBreakdown.isFetching;
const paymentBreakdownErrorSelector = (state: RootState) => state.admin.details_finance_report.paymentBreakdown.error;
export const selectPaymentBreakdownData = createSelector(paymentBreakdownDataSelector, (data) => data);
export const selectPaymentBreakdownError = createSelector(paymentBreakdownFetchingSelector, (error) => error);
export const selectPaymentBreakdownIsFetching = createSelector(paymentBreakdownErrorSelector, (isFetching) => isFetching);
